import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Tooltip } from "reactstrap";
import withRouter from "./withRouter";
import { useSelector } from "react-redux";

const Breadcrumbs = ({ items = [], transactionCode, transactionDescribe }) => {

  const [tbottom, settbottom] = useState(false)
  const {isIframePage} = useSelector(state => state.Layout.isIframePage)

  return (
    <React.Fragment>
      {items && items[0] && (items[0]?.chave || transactionCode) ?
        <div className="page-breadcrumb" style={{padding: isIframePage && '15px'}}>
          <div className="container-fluid page-title-box d-sm-flex align-items-center justify-content-between">
            <Breadcrumb listClassName="m-0">
              {items[0]?.chave && items?.map(({chave, transacao}, key) => (
                <BreadcrumbItem key={key} active>
                  <Link to={"/"+transacao}>{chave}</Link>
                </BreadcrumbItem>
              ))}
            </Breadcrumb>
            {transactionCode && (
              <div className="describe-transation">
                <span>Código: {transactionCode}</span>
                <div id="TooltipTop">
                  <i className="fas fa-info-circle"></i>
                </div>

                <Tooltip
                  placement="bottom"
                  className="tooltip-custom"
                  isOpen={tbottom}
                  target="TooltipTop"
                  toggle={() => {
                    settbottom(!tbottom);
                  }}
                >
                  {transactionDescribe || transactionCode}
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        : <div></div>
      }
    </React.Fragment>
  );
};

export default withRouter(Breadcrumbs);
